<template>
  <v-snackbar
    v-model="notification.value"
    :timeout="10000"
    :color="notification.type"
    location="center"
    class="text-body-2"
  >
    {{ notification.text }}
    <v-btn
      class="float-right"
      text
      variant="text"
      :icon="mdiClose"
      color="white"
      @click="notification.value = false"
    />
  </v-snackbar>
</template>

<script>
// Pinia stores
import { mapFields } from '@/store/helpers'
import { mdiClose } from '@mdi/js'

export default {
  data() {
    return {
      mdiClose
    }
  },
  computed: {
    ...mapFields({
      notification: 'app.notification'
    })
  }
}
</script>
